
import { defineComponent } from "vue";
import "@/assets/scss/component/contactus.scss";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "contact-us",
});
